import { mapState } from 'vuex';
import NiotaClassicApiService from '../../../../services/niotaClassicApiService';
import cloneDeep from 'lodash/cloneDeep';
import get from 'lodash/get';
export default {
  name: 'NiotaClassicDevicesDeviceDetailsDownlinks',
  props: {
    deviceData: {
      type: Object,
      required: false,
      default: null
    }
  },
  data: function () {
    return {
      selectedDownlink: null,
      downlinks: [],
      sendingDownlink: false,
      millisecondsDelay: 1000,
      fcnt: null
    };
  },
  computed: {
    ...mapState('app', ['color'])
  },
  watch: {},
  mounted() {
    this.downlinks = get(this.deviceData, 'deviceType.properties.downlinks');
  },
  methods: {
    sendDownlink() {
      this.fcnt = null;
      this.sendingDownlink = true;
      const downlinkPayload = cloneDeep(this.selectedDownlink);
      if (downlinkPayload.gatewayId !== null && downlinkPayload.gatewayId !== undefined && downlinkPayload.gatewayId.trim) {
        if (downlinkPayload.gatewayId.trim() === '') {
          downlinkPayload.gatewayId = undefined;
        }
      }
      NiotaClassicApiService.deviceSendDownlink(this.deviceData.id, downlinkPayload).then(res => {
        this.fcnt = get(res, 'data.sentPacket.fcnt');
        return new Promise(resolve => setTimeout(resolve, this.millisecondsDelay));
      }).then(() => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.sentDownlink'), 'success');
      }).finally(() => {
        this.sendingDownlink = false;
      }).catch(error => {
        let apiError = get(error, 'response.data.err');
        this.$snack(apiError || this.$i18n_t('NiotaClassic.Devices.snacks.failedDownlink'), 'error');
      });
    }
  }
};